export const authConstants = {
  userToken: 'userToken',
  adminToken: 'adminToken',
  hotelManagerToken: 'hotelManagerToken',
}